// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","button_element__highlight":"Button_button_element__highlight__O7et+","animated_text":"Button_animated_text__xBa+t"};